import React from 'react';

import { AttributeRow } from './attribute-row';
import { PickingExceptionAlert } from './picking-exception-alert';
import { DangerousGoodsDetails } from '../../../../../components/dangerous-goods/dangerous-goods-details/dangerous-goods-details';

/**
 * Renders additional sub-rows for an item in the items table.
 * @param {object} props
 * @param {object} props.row - The row data representing a single item.
 * @returns {JSX.Element} Fragment containing sub-row components.
 * */
export const ItemsTableSubRows = ({ row }) => {
  return (
    <>
      {/*
      originalQuantity has been removed from Apollo, so this needs to be
      updated to calculate adjustments differently
      <ItemAdjustmentNoticeRow row={row} />
      */}
      <PickingExceptionAlert row={row} />
      <DangerousGoodsDetails item={row} />
      <AttributeRow row={row} />
    </>
  );
};
